import React, {Component} from 'react';
import styles from "./classdata.module.css";
import back from '../../img/ic_back.png';
import badge from '../../img/badge.svg';
import dianzan0 from '../../img/dianzan.png';
import dianzan2 from '../../img/dianzan.svg';
import gaijin from '../../img/ic_quantou.svg';

import badgeYuyan from "../../img/badge_yuyan.svg";

import badgeCenter from "../../img/badge_center.svg";

import badgeTiyu from "../../img/badge_tiyu.svg";
import badgeYishu from "../../img/badge_yishu.svg";
import badgeShuxue from "../../img/badge_shuxue.svg";
import badgeLaodong from "../../img/badge_laodong.svg";
import badgePinde from "../../img/badge_pinde.svg";
import dianzan from "../../img/ic_dianzan.svg";
import huizhang from "../../img/huizhang.svg";

import defaultImg from '../../img/bee.png';
import first from '../../img/first.png';
import second from '../../img/second.png';
import third from '../../img/third.png';
import icCaiji from "../../img/ic_caiji_green.svg";

const ClassData = props => (

    <div className={styles.root}>
        <div className={styles.menubar}>
            <img className={styles["img-back"]} src={back} onClick={props.closeClassdataModal}/>
            <div className={styles["modal-title"]}>班级数据</div>
        </div>

        <div className={styles.container}>
            <div className={styles["div-zongji"]}>
                <img className={styles["img-badge"]} src={badge}/>
                <div>班级学生徽章</div>
                <div className={styles["text-zongji"]}>{props.huizhang_num}</div>

                <img className={styles["img-dianzan2"]} src={dianzan2}/>
                <div>班级学生点赞</div>
                <div className={styles["text-zongji"]}>{props.dianzan_num}</div>

                <img className={styles["img-dianzan2"]} src={dianzan2}/>
                <div>班级点赞</div>
                <div className={styles["text-zongji"]}>{props.class_dianzan}</div>

                {/*<img className={styles["img-badge"]} src={gaijin}/>*/}
                {/*<div>班级待改进</div>*/}
                {/*<div className={styles["text-zongji"]}>{props.class_gaijin}</div>*/}
            </div>

            <div className={styles["container-fengchao"]}>
                <img className={styles["badge-yuyan"]}
                     src={badgeYuyan}/>
                <img className={styles["badge-center"]} src={badgeCenter}/>
                <img className={styles["badge-laodong"]} src={badgeLaodong}/>
                <img className={styles["badge-pinde"]} src={badgePinde}/>
                <img className={styles["badge-tiyu"]} src={badgeTiyu}/>
                <img className={styles["badge-shuxue"]} src={badgeShuxue}/>
                <img className={styles["badge-yishu"]} src={badgeYishu}/>
                {/*语言与人文*/}
                <div className={styles["div-badge-yuyan"]}>
                    <div className={styles["text-tongji-num"]}>{props.renwen[0]}</div>
                    <img className={styles["img-dianzan"]} src={huizhang}/>
                </div>
                <div className={styles["div-dianzan-yuyan"]}>
                    <img className={styles["img-dianzan"]} src={dianzan}/>
                    <div className={styles["text-tongji-num"]}>{props.renwen[1]}</div>
                </div>
                {/*劳动与科创*/}
                <div className={styles["div-badge-laodong"]}>
                    <img className={styles["img-dianzan"]} src={huizhang}/>
                    <div className={styles["text-tongji-num"]}>{props.laodong[0]}</div>
                </div>
                <div className={styles["div-dianzan-laodong"]}>
                    <img className={styles["img-dianzan"]} src={dianzan}/>
                    <div className={styles["text-tongji-num"]}>{props.laodong[1]}</div>
                </div>

                {/*品德与修养*/}
                <div className={styles["div-badge-pinde"]}>
                    <img className={styles["img-dianzan"]} src={huizhang}/>
                    <div className={styles["text-tongji-num"]}>{props.pinde[0]}</div>
                </div>
                <div className={styles["div-dianzan-pinde"]}>
                    <img className={styles["img-dianzan"]} src={dianzan}/>
                    <div className={styles["text-tongji-num"]}>{props.pinde[1]}</div>
                </div>
                {/*体育与健康*/}
                <div className={styles["div-badge-tiyu"]}>
                    <div className={styles["text-tongji-num"]}>{props.tiyu[0]}</div>
                    <img className={styles["img-dianzan"]} src={huizhang}/>
                </div>
                <div className={styles["div-dianzan-tiyu"]}>
                    <img className={styles["img-dianzan"]} src={dianzan}/>
                    <div className={styles["text-tongji-num"]}>{props.tiyu[1]}</div>
                </div>
                {/*数学与思维*/}
                <div className={styles["div-badge-shuxue"]}>
                    <div className={styles["text-tongji-num"]}>{props.shuxue[0]}</div>
                    <img className={styles["img-dianzan"]} src={huizhang}/>
                </div>
                <div className={styles["div-dianzan-shuxue"]}>
                    <div className={styles["text-tongji-num"]}>{props.shuxue[1]}</div>
                    <img className={styles["img-dianzan"]} src={dianzan}/>
                </div>

                {/*艺术与审美*/}
                <div className={styles["div-badge-yishu"]}>
                    <div className={styles["text-tongji-num"]}>{props.yishu[0]}</div>
                    <img className={styles["img-dianzan"]} src={huizhang}/>
                </div>
                <div className={styles["div-dianzan-yishu"]}>
                    <div className={styles["text-tongji-num"]}>{props.yishu[1]}</div>
                    <img className={styles["img-dianzan"]} src={dianzan}/>
                </div>
            </div>

            <div className={styles["container-paiming"]}>

                <div className={styles["container-zhibiao"]}>

                <div className={styles.divInput}>
                    <div className={styles.input2} onClick={props.openClassValue}>
                        <div
                            className={styles.title}>{props.juese_name == '' ? '' : props.juese_name}</div>
                        <div className={styles.arrow}></div>
                    </div>
                    <div id='option' className={
                        props.showJuese ? styles.list2 : styles.list}>
                        <ul className={styles.ul}>
                            {
                                props.termInfo.map((item, index) => {
                                    return (
                                        <li className={styles.li}
                                            onClick={props.getClassValue.bind(null, item.name, item.code, index)}
                                            key={item.code}>{item.name}</li>);
                                })
                            }
                        </ul>
                    </div>
                </div>

                {/*<div className={props.zhibiaoTab==1?styles["zhibiao-selected"]:styles["zhibiao-unselected"]}>学院</div>*/}
                <div className={props.zhibiaoTab1?styles["zhibiao-selected"]:styles["zhibiao-unselected"]}
                    onClick={props.clickZhibiaoTab.bind(null,1)}>一级指标</div>
                <div className={props.zhibiaoTab2?styles["zhibiao-selected"]:styles["zhibiao-unselected"]}
                     onClick={props.clickZhibiaoTab.bind(null,2)}>二级指标</div>
                <div className={props.zhibiaoTab3?styles["zhibiao-selected"]:styles["zhibiao-unselected"]}
                     onClick={props.clickZhibiaoTab.bind(null,3)}>三级指标</div>
                </div>

             {/*   {props.zhibiaoTab1?
                    <div className={styles["list-warpper"]}>
                        {
                            props.xueyuanList.map((item,index) => {
                                return (
                                    <div className={styles["list-item"]}>
                                        <div className={props.xueyuan_code==item.xueyuan_code?styles["xueyuan-selected"]:styles["xueyuan-unselected"]}
                                             onClick={props.clickXueyuan.bind(null,item.xueyuan_code,index)}>
                                            {item.xueyuan_name}
                                        </div>
                                        {props.xueyuan_code==item.xueyuan_code?
                                            <div className={styles.line2}></div>
                                            :null}
                                    </div>);
                            })
                        }
                    </div>
                :null}*/}

                {props.zhibiaoTab1?
                    <div className={styles["list-warpper-xueke"]}>
                        <div>学院：</div>
                        {
                            props.xueyuanList.map((item,index) => {
                                return (
                                    <div className={styles["list-item-xueke"]}>
                                        <div className={props.xueyuan_code==item.xueyuan_code?styles["xueke-selected"]:styles["xueke-unselected"]}
                                             onClick={props.clickXueyuan.bind(null,item.xueyuan_code,index)}>
                                            {item.xueyuan_name}
                                        </div>
                                    </div>);
                            })
                        }
                    </div>
                    :null}


                {props.zhibiaoTab1?
                    <div className={styles["list-warpper-xueke"]}>

                        <div>一级指标：</div>
                        {
                            props.xuekeList.map((item,index) => {
                                return (
                                    <div className={styles["list-item-xueke"]}>
                                        <div className={props.xueke_code==item.xueke_code?styles["xueke-selected"]:styles["xueke-unselected"]}
                                             onClick={props.clickXueke.bind(null,item.xueke_code,index)}>
                                            {item.xueke_name}
                                        </div>
                                    </div>);
                            })
                        }
                    </div>
                    :null}

                {props.zhibiaoTab2?
                    <div className={styles["list-warpper-xueke"]}>
                        <div>二级指标：</div>
                        {
                            props.zhibiao2List.map((item) => {
                                return (
                                    <div className={styles["list-item-xueke"]}>
                                        <div className={props.erji_code==item.erji_code?styles["xueke-selected"]:styles["xueke-unselected"]}
                                             onClick={props.clickZhibiao2.bind(null,item.erji_code)}>
                                            {item.erji_name}
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    :null}

                {props.zhibiaoTab3?
                    <div className={styles["list-warpper-xueke"]}>
                        <div>三级指标：</div>
                        {
                            props.zhibiao3List.map((item) => {
                                return (
                                    <div className={styles["list-item-xueke"]}>
                                        <div className={props.sanji_code==item.sanji_code?styles["xueke-selected"]:styles["xueke-unselected"]}
                                             onClick={props.clickZhibiao3.bind(null,item.sanji_code)}>
                                            {item.sanji_name}
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    :null}


                {/*{props.xueke_code!=='26'&&props.xueke_code!=='27'?*/}
                    {/*<div className={styles["list-warpper-liyou"]}>*/}
                        {/*{*/}
                            {/*props.liyouList.map((item) => {*/}
                                {/*return (*/}

                                    {/*<div className={styles["item-liyou"]}*/}
                                         {/*onClick={props.clickLiyou.bind(null,item.dianzan_code)}>*/}
                                        {/*{item.liyou}*/}
                                    {/*</div>*/}
                                {/*);*/}
                            {/*})*/}
                        {/*}*/}
                    {/*</div> :null}*/}

                {!props.zhibiaoTab1&&!props.zhibiaoTab2&&!props.zhibiaoTab3?
                    <div>
                        {props.studentList.length>0 ?
                            <div>
                                <table className={styles.table}>
                                    <thead>
                                    <tr>
                                        <td className={styles.td0}></td>
                                        <td className={styles.td0}>姓名</td>
                                        <td className={styles.td0}>徽章总计</td>
                                        <td className={styles.td0}>点赞总计</td>
                                        <td className={styles.td0}>品德</td>
                                        <td className={styles.td0}>思维</td>
                                        <td className={styles.td0}>艺术</td>
                                        <td className={styles.td0}>体育</td>
                                        <td className={styles.td0}>人文</td>
                                        <td className={styles.td0}>科创</td>
                                    </tr>
                                    </thead>

                                    {
                                        props.studentList.map((item, index, array) => {
                                            return (
                                                <tbody>
                                                <tr>
                                                    <td>
                                                        {index == 0 ? <img className={styles["list-item-img"]} src={first}/> : null}
                                                        {index == 1 ?
                                                            <img className={styles["list-item-img"]} src={second}/> : null}
                                                        {index == 2 ? <img className={styles["list-item-img"]} src={third}/> : null}
                                                        {index > 2 ?
                                                            <div className={styles["list-item-xuhao"]}>{index + 1}</div> : null}
                                                    </td>

                                                    <td className={styles["item-name"]}
                                                        onClick={props.chakanInfo.bind(null, item.pid, item.name,item.face_imgurl)}>
                                                        <div className={styles["item-info"]}>
                                                            <img className={styles["img-touxiang"]} src={item.img}
                                                                 onError={props.handleImageErrored.bind(this, index)}/>
                                                            <div>
                                                                {item.name}
                                                            </div>
                                                            {item.face_imgurl==''||item.face_imgurl==null?null:
                                                                <img className={styles["img-caiji"]} src={icCaiji}/>
                                                            }
                                                        </div>
                                                    </td>
                                                    <td>{item.huizhang}</td>
                                                    <td>{item.dianzan}</td>
                                                    <td>{item.huizhang_xueyuan[0].value}</td>
                                                    <td>{item.huizhang_xueyuan[1].value}</td>
                                                    <td>{item.huizhang_xueyuan[2].value}</td>
                                                    <td>{item.huizhang_xueyuan[3].value}</td>
                                                    <td>{item.huizhang_xueyuan[4].value}</td>
                                                    <td>{item.huizhang_xueyuan[5].value}</td>

                                                </tr>
                                                </tbody>
                                            )
                                        })
                                    }

                                </table>
                            </div>
                            :
                            <div>
                                <table className={styles.table}>
                                    <thead>
                                    <tr>
                                        <td className={styles.td0}></td>
                                        <td className={styles.td0}>姓名</td>
                                        <td className={styles.td0}>徽章总计</td>
                                        <td className={styles.td0}>点赞总计</td>
                                        <td className={styles.td0}>品德</td>
                                        <td className={styles.td0}>思维</td>
                                        <td className={styles.td0}>艺术</td>
                                        <td className={styles.td0}>体育</td>
                                        <td className={styles.td0}>人文</td>
                                        <td className={styles.td0}>科创</td>
                                    </tr>
                                    </thead>

                                    <thead>
                                    <tr>
                                        <td className={styles.td0}></td>
                                        <td className={styles.td0}></td>
                                        <td className={styles.td0}></td>
                                        <td className={styles.td0}></td>
                                        <td className={styles.td00}>暂无数据</td>
                                        <td className={styles.td0}></td>
                                        <td className={styles.td0}></td>
                                        <td className={styles.td0}></td>
                                        <td className={styles.td0}></td>
                                        <td className={styles.td0}></td>
                                    </tr>
                                    </thead>
                                </table>
                            </div>

                        }
                    </div>
                :null}

                {props.zhibiaoTab1||props.zhibiaoTab2||props.zhibiaoTab3?
                    <div>
                        {props.studentListNew.length>0 ?
                            <div className={styles.lt}>
                                <div className={styles['lt-item']}>
                                    <div className={styles["lt-item-paiming"]}></div>
                                    <div className={styles["lt-item-name0"]}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;姓名</div>
                                    <div className={styles["lt-item-dz0"]}>点赞统计</div>
                                </div>

                                <div className={styles['lt-item']}>
                                    <div className={styles["lt-item-paiming"]}></div>
                                    <div className={styles["lt-item-name0"]}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;姓名</div>
                                    <div className={styles["lt-item-dz0"]}>点赞统计</div>
                                </div>

                                <div className={styles['lt-item']}>
                                    <div className={styles["lt-item-paiming"]}></div>
                                    <div className={styles["lt-item-name0"]}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;姓名</div>
                                    <div className={styles["lt-item-dz0"]}>点赞统计</div>
                                </div>

                                {
                                    props.studentListNew.map((item, index) => {
                                        return <div className={styles['lt-item']}>
                                            <div className={styles["lt-item-paiming"]}>
                                                {index == 0 ? <img className={styles["list-item-img"]} src={first}/> : null}
                                                {index == 1 ?
                                                    <img className={styles["list-item-img"]} src={second}/> : null}
                                                {index == 2 ? <img className={styles["list-item-img"]} src={third}/> : null}
                                                {index > 2 ?
                                                    <div className={styles["list-item-xuhao"]}>{index + 1}</div> : null}
                                            </div>

                                            <div className={styles["lt-item-name"]}
                                                 onClick={props.chakanInfo.bind(null, item.pid, item.stu_name,item.img)}>
                                                <div className={styles["item-info"]}>
                                                    <img className={styles["img-touxiang"]} src={item.img}
                                                         onError={props.handleImageErrored2.bind(this, index)}/>
                                                    <div className={styles.name3}>
                                                        {item.stu_name}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={styles["lt-item-dz"]}>{item.total_num}</div>
                                        </div>;
                                    })
                                }
                            </div>
                            : <div className={styles.td00}>暂无数据</div>}
                    </div>
                :null}







            </div>

        </div>

    </div>

)

export default ClassData;
